import React, { Component } from 'react'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'
import moment from 'moment'

const orderConcerts = (concerts, upcoming) => {
  if (upcoming) {
    return concerts
      .slice()
      .sort((a, b) => (a.concertDate > b.concertDate ? 1 : -1))
  }
  return concerts
    .slice()
    .sort((a, b) => (a.concertDate < b.concertDate ? 1 : -1))
}

export default (upcoming = true, prop = 'concerts') => WrappedComponent =>
  class WithConcerts extends Component {
    render() {
      return (
        <Query
          query={gql`
            query getUpcomingConcerts(
              $date: String
              $compare: RootQueryToConcertConnectionWhereArgsMetaCompareEnum
            ) {
              concerts(
                where: {
                  metaQuery: {
                    metaArray: [
                      {
                        key: "concertDate"
                        value: $date
                        compare: $compare
                        type: DATE
                      }
                    ]
                  }
                }
                first: 99
              ) {
                nodes {
                  title
                  link
                  concertDate
                  ticketLink
                  ticketStatus
                  setup {
                    title
                    link
                    tourCalendarTitle
                  }
                }
              }
            }
          `}
          variables={{
            date: moment().format('YYYY-MM-DD'),
            compare: upcoming ? 'GREATER_THAN_OR_EQUAL_TO' : 'LESS_THAN'
          }}
        >
          {({ loading, error, data }) => (
            <div>
              {!error && (
                <WrappedComponent
                  {...this.props}
                  {...{
                    [`${prop}Loading`]: loading,
                    [`${prop}`]:
                      !loading && !error
                        ? orderConcerts(data.concerts.nodes, upcoming)
                        : []
                  }}
                />
              )}
              {error && <h1>Error: {error.message}</h1>}
            </div>
          )}
        </Query>
      )
    }
  }



// WEBPACK FOOTER //
// ./src/containers/withConcerts.js